import { SVGProps, Ref, forwardRef } from 'react'
const SvgCamera = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M.75 5.261h15v13.5h-15v-13.5ZM18.75 15.011l3.415 1.707a.75.75 0 0 0 1.085-.671V7.974a.75.75 0 0 0-1.085-.67L18.75 9.011"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCamera)
export default ForwardRef
